import React, { useState, useEffect } from 'react';
import config from '../../Common/Configurations/APIConfig';
import apiService from "../../Common/Configurations/APIService";
import Header from '../../Common/Layout/Header';
import { useAuth } from '../../Common/Configurations/AuthContext';
import Modal from 'react-bootstrap/Modal';
import { Link, useNavigate } from 'react-router-dom';
import DeleteAlert from '../../Common/Layout/DeleteAlert';
import SettingsTabs from "../Settings/SettingsTabs";
const initialFieldValues = {
    faqCategoryId: "00000000-0000-0000-0000-000000000000",
    faqCategoryName: "",
};

const FaqCategory = () => {
    const navigate = useNavigate();
    const { user, loading } = useAuth();
    const [btnLoading, setBtnLoading] = useState(false);
    const [lists, setLists] = useState([]); // Initialized as empty array
    const [values, setValues] = useState(initialFieldValues);
    const [errors, setErrors] = useState({});
    const [recordForEdit, setRecordForEdit] = useState(null);
    
    // Pagination states (Might not be used if API returns all data at once)
    const [totalPages, setTotalPages] = useState(0);
    const [pageSize, setPageSize] = useState(20);
    const [pageNumber, setPageNumber] = useState(1);
    const [data, setData] = useState([]); 
    const [totalRecords, setTotalRecords] = useState(0);
    
    const [addShow, setAddShow] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);

    const handleOpenDeleteModal = (id) => {
        setItemToDelete(id);
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
        setItemToDelete(null);
    };

    const handleAddClose = () => {
        setAddShow(false);
        setRecordForEdit(null);
    };

    const handleAddShow = () => {
        setRecordForEdit(null);
        setValues(initialFieldValues);
        setAddShow(true);
    };

    useEffect(() => {
        if (recordForEdit !== null) {
            setValues(recordForEdit);
        }
    }, [recordForEdit]);

    // --- FIX IS HERE ---
    const GetData = async (pageNumber) => {
        try {
            const res = await apiService.getAll(`${config.GETALLFAQCATEGORY}`);
            console.log("API Response:", res);

            // Check if response is an array (Direct list)
            if (Array.isArray(res)) {
                setLists(res);
                setTotalRecords(res.length);
                setTotalPages(1); // Since it's a flat list, assume 1 page
            } 
            // Check if response is paginated object
            else if (res && res.data) {
                setLists(res.data);
                setPageNumber(res.pageNumber || 1);
                setPageSize(res.pageSize || 20);
                setTotalPages(res.totalPages || 0);
                setData(res); // Store full response if needed
                setTotalRecords(res.totalRecords || 0);
            } 
            else {
                setLists([]); // Fallback
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setLists([]);
        }
    };

    const GetLastPageData = () => {
        // Only works if API supports pagination params
        GetData(totalPages)
    }

    const GetFirstPageData = () => {
        GetData("1")
    }

    const GetPageData = (number) => {
        setPageNumber(number);
        if (pageNumber !== number)
            GetData(number)
    }

    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
    }

    const renderPageNumbers = pageNumbers.map((number) => {
        return (
            <li className="page-item" key={number} id={number} onClick={() => GetPageData(number)}>
                <Link className="page-link">{number}</Link>
            </li>
        );
    });

    const showEditDetails = (data) => {
        setRecordForEdit(data);
        setValues(data);
        setAddShow(true);
    };

    const handleDelete = async () => {
        if (itemToDelete !== null) {
            try {
                await apiService.remove(config.DELETEFAQCATEGORY, itemToDelete)
                await GetData(pageNumber);
            } catch (error) {
                console.error(error);
            }
            handleCloseDeleteModal();
        }
    }

    const validate = () => {
        let temp = {};
        temp.faqCategoryName = values.faqCategoryName === "" ? false : true;
        setErrors(temp);
        return Object.values(temp).every((x) => x === true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validate()) {
            setBtnLoading(true);
            var formData = {
                "faqCategoryId": values.faqCategoryId,
                "faqCategoryName": values.faqCategoryName,
            }
            try {
                const isNew = formData.faqCategoryId === "00000000-0000-0000-0000-000000000000";

                if (isNew) {
                    await apiService.create(config.CREATEFAQCATEGORY, formData);
                } else {
                    await apiService.update(config.UPDATEFAQCATEGORY, formData);
                }
                await GetData(pageNumber);
                resetForm();

            } finally {
                setBtnLoading(false);
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const fieldsToUppercase = [""]; 
        setValues({
            ...values,
            [name]: fieldsToUppercase.includes(name) ? value.toUpperCase() : value
        });
    };

    const resetForm = () => {
        setValues(initialFieldValues);
        setAddShow(false);
        setBtnLoading(false);
    };

    const applyErrorClass = (field) => field in errors && errors[field] === false ? " form-control-danger" : "";

    useEffect(() => {
        if (user && !loading) {
            GetData(pageNumber);
        }
    }, [user, loading]);

    if (loading) return <p>Loading...</p>;
    if (!user) { navigate("/") };

    return (
        <div id="layout-wrapper">
            <Header User={user} />
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="col-xl-12">
                            <div className="card">
                                  <div className="p-2">
                                                  <SettingsTabs pageName="FAQCATEGORY" />
                                                </div>
                                <div className="p-2"></div>
                                <div className="me-2 pb-1">
                                    <div className="row g-4 align-items-center">
                                        <div className="col-sm-auto ms-auto">
                                            <div className="hstack gap-2">
                                                <button type="button" className="btn btn-primary add-btn" onClick={handleAddShow} >
                                                    <i className="ri-add-line align-bottom me-1" /> Add FAQ Category
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive table-card p-2">
                                        <table className="table align-middle" id="customerTable">
                                            <thead className="bg-soft-success bg-gradient">
                                                <tr>
                                                    <th>Id</th>
                                                    <th>Category Name</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody className="list form-check-all">
                                                {/* --- FIX IS HERE: Safe check for lists --- */}
                                                {lists && lists.length > 0 ? lists.map((v, index) =>
                                                    <tr key={v.faqCategoryId}>
                                                        <td>{index + 1}</td>
                                                        <td>{v.faqCategoryName}</td>
                                                        <td>
                                                            <ul className="list-inline hstack gap-2 mb-0">
                                                                <li className="list-inline-item" title="Edit">
                                                                    <Link className="edit-item-btn" onClick={e => showEditDetails(v)}>
                                                                        <i className="ri-pencil-fill align-bottom text-muted" />
                                                                    </Link>
                                                                </li>
                                                                <li className="list-inline-item" title="Delete">
                                                                    <Link className="remove-item-btn" onClick={e => handleOpenDeleteModal(v.faqCategoryId)}>
                                                                        <i className="ri-delete-bin-fill align-bottom text-muted" />
                                                                    </Link>
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    <tr>
                                                        <td colSpan="3" className="text-center">No Data Found</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                                        <div className="flex-shrink-0">
                                            <div className="text-muted">
                                                Showing <span className="fw-semibold">{lists ? lists.length : 0}</span> of <span className="fw-semibold">{totalRecords}</span> Results
                                            </div>
                                        </div>
                                        <ul className="pagination pagination-separated pagination-sm mb-0">
                                            <li className={"page-item" + (data && data.previousPage === null ? ' disabled' : '')} onClick={() => GetFirstPageData()}>
                                                <Link className="page-link">Previous</Link>
                                            </li>
                                            {renderPageNumbers}
                                            <li className={"page-item" + (data && data.nextPage === null ? ' disabled' : '')} onClick={() => GetLastPageData()}>
                                                <Link className="page-link">Next</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal show={addShow} onHide={handleAddClose}>
                    <Modal.Header>
                        <Modal.Title>{values.faqCategoryId === "00000000-0000-0000-0000-000000000000" ? "Add" : "Edit"} FAQ Category</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                            <div className="row">
                                <div className="col-lg-12 mb-3">
                                    <label htmlFor="faqCategoryName" className="form-label">Category Name</label>
                                    <input 
                                        type="text" 
                                        max={45} 
                                        value={values.faqCategoryName} 
                                        name="faqCategoryName" 
                                        onChange={handleInputChange} 
                                        className={"form-control" + applyErrorClass('faqCategoryName')} 
                                        placeholder="Please Enter Category Name" 
                                    />
                                    {errors.faqCategoryName === false ? (<div className="validationerror">Please enter name </div>) : ('')}
                                </div>
                                <Modal.Footer>
                                    <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                                        {
                                            btnLoading === false ?
                                                <button type="submit" className="btn btn-primary">
                                                    {values.faqCategoryId === "00000000-0000-0000-0000-000000000000" ? "Submit" : "Update"}
                                                </button>
                                                :
                                                <button type="submit" className="btn btn-primary" disabled>Please wait...</button>
                                        }
                                        <button type="button" className="btn btn-danger" onClick={resetForm}>Cancel</button>
                                    </div>
                                </Modal.Footer>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
                <DeleteAlert show={showDeleteModal} handleClose={handleCloseDeleteModal} handleDelete={handleDelete} />
            </div>
        </div>
    );
};

export default FaqCategory;